import Vue from "vue"
import User from "@/lib/user"
import { BudgetsAPI } from "@/lib/api"
import {
  SET_BUDGETS,
  SET_BUDGET,
  ADD_BUDGET,
  UPDATE_BUDGET,
  DELETE_BUDGET
} from "@/store/mutationTypes"

const state = {
  all: []
}
const getters = {
  getBudgets: state => {
    return state.all
  },
  getBudgetsByUser: (state, getters) => userId => {
    return state.all.filter(el => el.user_id === parseInt(userId))
  },
  getBudgetById: (state, getters) => id => {
    return state.all.find(el => el.id === parseInt(id))
  }
}
// actions
const actions = {
  async loadBudgets({ commit }, userId) {
    commit(SET_BUDGETS, await BudgetsAPI.list(userId))
  },
  async loadBudget({ commit, dispatch }, { id }) {
    let budget = await BudgetsAPI.get(id)
    commit(SET_BUDGET, budget)
    return budget
  },
  async addBudget({ commit }, json) {
    let budget = await BudgetsAPI.create(json)
    commit(ADD_BUDGET, budget)
    return budget
  },
  async updateBudget({ commit }, { id, payload }) {
    let budget = await BudgetsAPI.update(id, payload)
    commit(UPDATE_BUDGET, budget)
    return budget
  },
  async deleteBudget({ commit }, id) {
    await BugetsAPI.delete(id)
    commit(DELETE_BUDGET, id)
  }
}

// mutations
const mutations = {
  [SET_BUDGETS](state, budgets) {
    state.all = budgets
  },
  [SET_BUDGET](state, budget) {
    let foundBudget = state.all.find(el => el.id === budget.id)
    if (foundBudget) {
      foundBudget = budget
    } else {
      state.all.push(budget)
    }
  },
  [ADD_BUDGET](state, budget) {
    state.all.push(budget)
  },
  [UPDATE_BUDGET](state, budget) {
    let foundToUpdate = state.all.find(el => budget.id === el.id)
    for (const key in budget) {
      Vue.set(foundToUpdate, key, budget[key])
    }
    // foundToUpdate = Object.assign({}, foundToUpdate, budget)
  },
  [DELETE_BUDGET](state, id) {
    state.all = state.all.filter(el => el.id != id)
  },
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
